/* --------------------------------------------------------------------------
   Sticky + shrinking store header (mirrors the main touchdro.com site).

   - On load / resize: measure the actual rendered header height and push
     <main> down by that amount so fixed-positioned content doesn't overlap.
   - On scroll: once we've scrolled past 50px, add `.shrink` so the header
     reduces its padding + logo size; remove it when we scroll back to top.
   -------------------------------------------------------------------------- */

function syncMainOffsetToHeader() {
  var header = document.querySelector('.site-header');
  var main = document.querySelector('main');
  if (!header || !main) return;
  // Exact header height — no padding buffer — so full-bleed hero sections
  // butt right up against the dark header with no white strip between them.
  // Sections that want breathing room can add their own top padding.
  var headerHeight = header.offsetHeight;
  main.style.marginTop = headerHeight + 'px';
}

window.addEventListener('load', syncMainOffsetToHeader);
window.addEventListener('resize', syncMainOffsetToHeader);

window.addEventListener('scroll', function () {
  var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  var header = document.querySelector('.site-header');
  if (!header) return;

  if (scrollTop > 50) {
    header.classList.add('shrink');
  } else {
    header.classList.remove('shrink');
  }
});
